export default __webpack_public_path__ + "static/ti_grey_sparkle-a2061443b774b05da092dc5338fa392f.png";